<div class="tabbar tab-style2" [ngClass]="{ 'navbar-pwa': pwaService.isInstalled() }">
  <ul class="flex flex-row align-items-center justify-content-center" [ngClass]="{ 'navbar-pwa': pwaService.isInstalled() }">
    @for (item of menu; track item) {
      <li [ngClass]="{ 'active': item.active, 'navbar-pwa': pwaService.isInstalled(), 'hidden': item.visible == false }">
        <span class="material-icons-outlined" (click)="goTo(item.path)">
          {{ item.icon }}
        </span>
      </li>
    }
  </ul>
</div>